import { useCallback, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useModal } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Modal';
import useAttemptStore from '@monorepo/shared/src/graph/state/query-hooks/use-attempt-store';
import NewSticker from 'components/modules/Rewards/NewSticker';
import {
  AttemptStatus,
  StudentReward,
  type Maybe,
} from '@monorepo/shared/src/graph/schema-generated-types-student';
import { AppRoutes } from 'types';

const DEFAULT_CHARACTER = 'A';

type Props = {
  studentReward?: Maybe<StudentReward> | undefined;
  skipAttemptUpdate?: boolean;
};

const ActivityCompletion: React.FC<Props> = ({ studentReward, skipAttemptUpdate }) => {
  const [, { openModal, closeModal }] = useModal();
  const [, { handleSaveAttempt }] = useAttemptStore();
  const { search, state } = useLocation();
  const { assignmentActivityId } = useParams();
  const navigate = useNavigate();

  const query = new URLSearchParams(search);
  const bookCode = query.get('bookCode');
  const assignmentId = query.get('assignmentId');
  const letter = bookCode?.slice(-1) || DEFAULT_CHARACTER;
  const shouldSkipAttemptUpdate =
    skipAttemptUpdate ?? (state as { skipAttemptUpdate?: boolean } | null)?.skipAttemptUpdate;

  const handleOnClose = async () => {
    closeModal();
  };

  const openNewRewardDialog = (reward: Maybe<StudentReward> | undefined) => {
    const maybeReward = studentReward ?? reward;
    openModal({
      body: (
        <NewSticker
          character={letter}
          onClose={handleOnClose}
          isActivityAffirmation
          studentReward={maybeReward}
        />
      ),
      getContainerStyles: (defaultStyles) => ({
        ...defaultStyles,
        maxWidth: '100vw',
        width: '100vw',
      }),
      getPaperStyles: (defaultStyles) => ({
        ...defaultStyles,
        maxWidth: '100vw',
        width: '100vw',
      }),
    });
  };
  const postActivity = useCallback(async () => {
    if (!assignmentActivityId) return;
    let result;
    if (!shouldSkipAttemptUpdate) {
      result = await handleSaveAttempt({
        assignmentActivityId: JSON.parse(assignmentActivityId),
        status: AttemptStatus.COMPLETED,
        dateCompleted: new Date(),
      });
    }
    openNewRewardDialog(result?.studentReward);
  }, [assignmentActivityId, shouldSkipAttemptUpdate]);

  useEffect(() => {
    postActivity();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      navigate(`/${AppRoutes.ASSIGNMENTS}/${assignmentId}`);
    }, 6000);
  }, []);

  return null;
};

export default ActivityCompletion;
